normalizeConfig